export default {"src":"/_next/static/media/np.e8c33143.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};